var exports = {
  "kL": "AvatarStack.module__container___SjMxSG",
  "my": "AvatarStack.module__avatar___SjMxSG",
  "KI": "AvatarStack.module__avatarButton___SjMxSG",
  "vn": "AvatarStack.module__avatarContent___SjMxSG",
  "ML": "AvatarStack.module__avatarContextMenuWrap___SjMxSG",
  "hm": "AvatarStack.module__withMask___SjMxSG",
  "i1": "AvatarStack.module__remainingCount___SjMxSG",
};

module.exports = exports;
